import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './HomeSistemaImoveis.module.css';
import { API_BASE_URL } from '../../config'; 
import PageHeader from '../../components/PageHeader/PageHeader';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';

import { FiTrendingUp } from 'react-icons/fi';
import { FaBuilding, FaHome, FaFileInvoiceDollar, FaHandshake, FaUserTie } from 'react-icons/fa';

const navItems = [
  { to: "/cadastro-imoveis", icon: <FaBuilding />, title: "Cadastrar Imóvel" },
  { to: "/view-imoveis", icon: <FaHome />, title: "Listar Imóveis" },
  { to: "/despesas-gerais", icon: <FaFileInvoiceDollar />, title: "Despesas Gerais" },
];

const SecondaryStats = ({ stats }) => {
  const secondaryStats = [
    { label: 'Imóveis Arrendados', value: stats?.arrendados || 0, icon: <FaHandshake /> },
    { label: 'Imóveis Próprios', value: stats?.proprios || 0, icon: <FaUserTie /> },
  ];

  return (
    <div className={styles.frotaChartContainer}>
      <div className={styles.frotaChartHeader}>
        <FiTrendingUp />
        <h3>Dados de Imóveis</h3>
      </div>
      <div className={styles.statsSubGrid}>
        {secondaryStats.map(item => (
          <div key={item.label} className={styles.subStatCard}>
            <div className={styles.subStatIcon}>{item.icon}</div>
            <div className={styles.subStatValue}>{item.value}</div>
            <div className={styles.subStatLabel}>{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const HomeSistemaImoveis = () => { 
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const MIN_LOADING_TIME = 300; 
    const startTime = Date.now();

    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) throw new Error('Token de autenticação não encontrado.');

        const response = await fetch(`${API_BASE_URL}/api/imoveis/stats`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Falha ao buscar os dados do painel.');
        }

        const data = await response.json();
        setStats(data);
      } catch (err) {
        setError(err.message);
      } finally {
        const endTime = Date.now();
        const duration = endTime - startTime;
        const remainingTime = MIN_LOADING_TIME - duration;

        if (remainingTime > 0) {
          setTimeout(() => setLoading(false), remainingTime);
        } else {
          setLoading(false);
        }
      }
    };

    fetchStats();
  }, []);

  return (
    <div className={styles.frotaDashboardLayout}>
      {loading && <LoadingOverlay text="Carregando..." />}

      {!loading && (
        <main className={styles.frotaMainArea}>
          
          <PageHeader 
          title="Painel de Imóveis" 
          subtitle="Selecione uma ação ou visualize os indicadores abaixo."
          backTo="/"
        />
          <div className={styles.actionsGrid}>
            {navItems.map(item => (
              <Link to={item.to} key={item.to} className={styles.actionCard}>
                <div className={styles.actionCardIcon}>{item.icon}</div>
                <span className={styles.actionCardTitle}>{item.title}</span>
              </Link>
            ))}
          </div>

          <h2 className={styles.sectionTitle}>Indicadores</h2>

          {error && <p className={styles.errorText}>{error}</p>}

          {!error && (
              <div className={styles.frotaDataGrid}>
                  <div className={styles.frotaTotalCard}>
                      <span className={styles.totalCardLabel}>Total de Imóveis</span>
                      <span className={styles.totalCardValue}>
                        {stats?.totalImoveis || 0}
                      </span>
                  </div>
                  <SecondaryStats stats={stats} />
              </div>
          )}
        </main>
      )}
    </div>
  );
};

export default HomeSistemaImoveis;